import React, { useEffect, useState } from "react";
import GearSpinner from '../../../components/GearSpinner/GearSpinner';
import Loader from '../../../components/Loader/Loader';
import printIcon from '../../../images/print-img.png';
import editIcon from '../../../images/edit-icon.png';
import shareIcon from '../../../images/share-img.png';
import pdfIcon from '../../../images/pdf-img.png';
import searchIcon from '../../../images/search-icon.png';
import xlsIcon from '../../../images/xls-img.png';
import AlertMessage from "../../../components/AlertMessage/AlertMessage";
import SharePurchaseOrderModal from "../../../components/Modals/SharePurchaseOrderModal";
import EditPurchaseOrderTable from "../tables/EditPurchaseOrderTable";
import PurchaseOrderService from "../../../services/PurchaseOrderService/PurchaseOrderService";
import '../print.css';
import { formatUSD } from '../../../utils/common';
import { Validation } from "../../../utils/validation";
import moment from "moment-timezone";

const SavedPO = ({ active, user }) => {
    const [detailLoader, setdetailLoader] = React.useState(false);
    const [historyLoader, setHistoryLoader] = React.useState(true);
    const [historyData, setHistoryData] = React.useState([]);
    const [formPayload, setFormPayload] = React.useState({ sales_data: [] });
    // const [filteredHistoryData, setFilteredHistoryData] = React.useState([]);
    const [showHistory, setShowHistory] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [poDetails, setPoDetails] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showShareModal, setShowShareModal] = useState(false);
    const [estTime, setEstTime] = useState("");
    const [alert, setAlert] = useState({ type: '', message: '' });
    const [isCompany, setIsCompany] = useState(false);
    const [products, setProducts] = useState([]);
    const [productMap, setProductMap] = useState({});
    const [multiplierMap, setMultiplierMap] = useState({});
    const [multiplierOptions, setMultiplierOptions] = useState([]);
    const [rowErrors, setRowErrors] = useState({});
    const [isProducts, setIsProducts] = useState(false);

    const parseNumber = (value) => {
        if (value === null || value === undefined || value === "") return 0;
        const num = Number(String(value).replace(/[^0-9.-]+/g, ""));
        return isNaN(num) ? 0 : num;
    };

    useEffect(() => {
        if (!active || !user?.name) return;
        if (active) {
            getPurchaseOrdersHistory();
        }
        setEstTime(
            moment()
                .tz("America/New_York")
                .format("MMMM DD, YYYY hh:mm:ss A z")
        );
    }, [active, user]);

    useEffect(() => {
        if (poDetails && isEdit) {
            let data = {
                "user_id": user?.id || "",
                "company_name": formPayload.company_name || ""
            };
            setShowLoader(true);
            purchaseOrderService.getCompanyDetailsAndProducts(data).then((response) => {
                const data = response.data;
                if (data.status === "success") {
                    if (isCompany) {
                        const mMap = {};
                        data.result.company_details.multipliers.forEach(m => {
                            mMap[m.multiplier_group] = Number(m.customer_multiplier);
                        });
                        setMultiplierMap(mMap);

                        const rawProducts = Array.isArray(data.result.products)
                            ? data.result.products
                            : Object.values(data.result.products).flat();

                        const pMap = {};
                        const productOptions = [];
                        rawProducts.forEach(p => {
                            pMap[p.num] = p;
                            productOptions.push({ value: p.num, label: p.num });
                        });

                        if (rawProducts.length > 0) setIsProducts(true);
                        setProductMap(pMap);
                        setProducts(productOptions);
                    } else {
                        const mMap = {};
                        const mOptionsMap = {};

                        data.result.company_details.forEach(company => {
                            company.multipliers.forEach(m => {
                                const val = Number(m.customer_multiplier);
                                if (!Number.isFinite(val)) return;
                                if (!mOptionsMap[val] && val > 0) {
                                    mOptionsMap[val] = { value: val, label: val.toFixed(3) };
                                }
                                mMap[val] = val;
                            });
                        });

                        const sortedMultiplierOptions = Object.values(mOptionsMap).sort(
                            (a, b) => Number(a.value) - Number(b.value)
                        );

                        setMultiplierMap(mMap);
                        setMultiplierOptions(Object.values(sortedMultiplierOptions));

                        const rawProducts = Array.isArray(data.result.products)
                            ? data.result.products
                            : Object.values(data.result.products).flat();

                        const pMap = {};
                        const productOptions = [];
                        rawProducts.forEach(p => {
                            pMap[p.num] = p;
                            productOptions.push({ value: p.num, label: p.num });
                        });

                        if (rawProducts.length > 0) setIsProducts(true);
                        setProductMap(pMap);
                        setProducts(productOptions);
                    }
                }
                setShowLoader(false);
            }).catch(error => {
                console.error('Error fetching multipliers:', error);
                setShowLoader(false);
            });
        }
    }, [isEdit]);

    const purchaseOrderService = new PurchaseOrderService();

    if (!active) return null;

    const getPurchaseOrdersHistory = async () => {
        setHistoryLoader(true);
        try {
            const response = await purchaseOrderService.getPurchaseOrdersHistory({ user_id: user?.id, data_status: 'saved' });
            if (response.data.status === 'success' && Array.isArray(response.data.result)) {
                setHistoryData(response.data.result);
            } else {
                setHistoryData([]);
            }
        } catch (error) {
            console.log("Error fetching quote history:", error);
            setHistoryData([]);
        } finally {
            setHistoryLoader(false);
        }
    };

    const filteredHistoryData = historyData.filter((item) => {
        const term = searchTerm.toLowerCase();
        return (
            item.order_number?.toLowerCase().includes(term) ||
            item.order_date?.toLowerCase().includes(term)
        );
    });

    const getPODetails = async (orderId) => {
        setdetailLoader(true);
        setIsEdit(false);
        purchaseOrderService.getPurchaseOrderDetails({ user_id: user?.id, order_id: orderId }).then((response) => {
            setdetailLoader(false);
            if (response.data.status === 'success') {
                setIsCompany(!!(response.data.result.order.company_name));
                setPoDetails(response.data.result);
                buildPayload(response.data.result);
            } else {
                setAlert({ type: 'danger', message: response.data.message || 'Failed to fetch purchase order details.' });
            }
        }).catch((error) => {
            setdetailLoader(false);
            console.log("Error fetching purchase order details:", error);
            setAlert({ type: 'danger', message: 'An error occurred while fetching purchase order details.' });
        })
    }

    const buildPayload = (data) => {
        const { order, items } = data || {};
        setFormPayload({
            id: order?.id,
            order_id: order?.id,
            user_id: order?.user_id,
            order_number: order?.order_number || "",
            order_date: order?.order_date || "",
            date_schedule: order?.date_schedule || "",
            company_name: order?.company_name || "",
            company_logo: poDetails?.company_details?.company_logo || "",
            company_initials: poDetails?.company_details?.company_initials || "",
            company_address: poDetails?.company_details?.company_address || "",
            company_street_address: poDetails?.company_details?.company_street_address || "",
            company_city_state_zip: poDetails?.company_details?.company_city_state_zip || "",
            rep: order?.rep || "",
            payment_terms: order?.payment_terms || "",
            fob_point: order?.fob_point || "",
            carrier: order?.carrier || "",
            ship_service: order?.ship_service || "",
            billing_address: order?.billing_address || "",
            shipping_address: order?.shipping_address || "",
            notes: order?.notes || "",
            sub_total: parseNumber(order?.sub_total) || "0",
            sales_tax: parseNumber(order?.sales_tax) || "0",
            total: parseNumber(order?.total) || "0",
            sales_data: (items || []).map(item => ({
                type: item.item_type || "Sale",
                product_number: item.product_number || "",
                description: item.description || "",
                unit_price: item.unit_price || "0",
                quantity: item.quantity || 0,
                total_price: item.total_price || "0",
                multiplier: item.multiplier ?? null,
                net_price: item.net_price || "0.00"
            })),
            est_timestamp: order?.est_timestamp || ""
        });
    };

    const handleEdit = () => {
        // Reset payload to original details before opening edit mode
        buildPayload(poDetails);
        setIsEdit(true);
        setShowHistory(false);

    }

    const handleResetEdit = () => {
        setIsEdit(false);
        setShowHistory(true);
        // Optional: Reset payload here as well to be safe
        buildPayload(poDetails);
    }

    const handlePrint = () => {
        window.print()

    }

    const handleShare = async (email, note, cc) => {
        setShowShareModal(false);
        setShowLoader(true);
        formPayload['sub_total'] = formatUSD(formPayload['sub_total']);
        formPayload['total'] = formatUSD(formPayload['total']);
        const ccList = cc ? (Array.isArray(cc) ? cc : cc.split(',').map(c => c.trim()).filter(Boolean)) : [];
        try {
            const res = await purchaseOrderService.sharePurchaseOrder({
                ...formPayload,
                email_to: [email],
                email_cc: ccList,
                po_note: note,
                format: 'pdf'
            });
            if (res && res.data && (res.data.response === 'success' || res.data.status === 'success')) {
                setAlert({ type: 'success', message: res.data.message || 'Purchase Order shared successfully.' });
                await getPurchaseOrdersHistory();
                setPoDetails(null);
                setFormPayload({ sales_data: [] });
            } else {
                setAlert({ type: 'danger', message: (res && res.data && res.data.message) || 'Email sending failed' });
            }
        } catch (err) {
            setAlert({ type: 'danger', message: 'Email sending failed' });
        } finally {
            setShowLoader(false);
            setShowShareModal(false);
        }
    };

    const handleShareClick = () => {
        setShowShareModal(true);

    }

    const exportPdf = () => {
        setShowLoader(true);
        let exportPayload = {
            ...formPayload,
            sub_total: formatUSD(formPayload.sub_total),
            total: formatUSD(formPayload.total),
            sales_tax: formatUSD(formPayload.sales_tax)
        };
        purchaseOrderService.exportPurchaseOrderPDF(exportPayload).then(response => {
            setShowLoader(false);
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `purchase-order-${exportPayload.order_number}.pdf`;
            link.click();
            window.URL.revokeObjectURL(url);
        }).catch(() => setShowLoader(false));

    }

    const exportExcel = () => {
        setShowLoader(true);
        let exportPayload = {
            ...formPayload,
            sub_total: formatUSD(formPayload.sub_total),
            total: formatUSD(formPayload.total),
            sales_tax: formatUSD(formPayload.sales_tax)
        };
        purchaseOrderService.exportPurchaseOrderExcel(exportPayload).then(response => {
            const url = window.URL.createObjectURL(response.data);
            const link = document.createElement('a');
            link.href = url;
            link.download = `purchase-order-${exportPayload.order_number}.xlsx`;
            link.click();
            setShowLoader(false);
        }).catch(() => setShowLoader(false));

    }

    const validateLocalForm = () => {
        if (!validateSalesRows()) {
            setAlert({ type: 'danger', message: 'Please select product number and quantity for all items.' });
            return false;
        }

        return true;
    };

    const validateSalesRows = () => {
        let currentErrors = {};
        console.log("Validating sales rows with payload:", formPayload);
        formPayload.sales_data.forEach((row, index) => {
            const errors = isCompany ? Validation(row, ['product_number', 'quantity']) : Validation(row, ['product_number', 'quantity', 'multiplier']);
            if (errors && Object.keys(errors).length > 0) {
                currentErrors[index] = errors;
            }
        });
        setRowErrors(currentErrors);
        return Object.keys(currentErrors).length === 0;
    };

    const handleUdpate = async () => {
        if (!validateLocalForm()) return;
        setShowLoader(true);
        await updatePO();

    }

    const updatePO = async () => {
        const payload = {
            ...formPayload,
            date_schedule: formPayload.date_schedule ? moment(formPayload.date_schedule).format('YYYY-MM-DD') : "",
            order_date: formPayload.order_date ? moment(formPayload.order_date).format('YYYY-MM-DD') : "",
            est_timestamp: estTime,
            sales_data: formPayload.sales_data.map(item => ({
                ...item,
                total_price: parseNumber(item.total_price),
                unit_price: parseNumber(item.unit_price),
                net_price: parseNumber(item.net_price)
            }))
        };
        try {
            const response = await purchaseOrderService.updatePurchaseOrderData(payload);
            if (response.data.status !== 'success') {
                setAlert({ type: 'error', message: response.data.message });
                throw new Error(response.data.message);
            }
            const targetOrderId = payload.order_id || payload.id;
            if (targetOrderId) {
                await getPODetails(targetOrderId);
            }
            await getPurchaseOrdersHistory();
            setIsEdit(false);
            setShowHistory(true);
        } catch (error) {
            setAlert({ type: 'error', message: error.message || 'Update failed' });
        } finally {
            setShowLoader(false);
        }
    }

    const renderDefaultDetails = () => {
        return (
            <React.Fragment>
                <div className="text-center my-5 fade-in">
                    <div className="p-5 rounded-3 shadow-sm bg-light border d-inline-block">
                        <h3 className="fw-bold text-dark">No Purchase Order Selected</h3>
                        <p className="text-muted mb-0">Please <span className="fw-semibold">select a purchase order</span> from the left to view details.</p>
                    </div>
                </div>
            </React.Fragment>
        )
    }

    const renderHistoryTable = () => {
        return (
            <React.Fragment>
                <table className="table text-center techtop-purchase-order-table2">
                    <thead>
                        <tr>
                            <th style={{ borderRight: "2px solid #fa4616" }}>Name</th>
                            <th>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {historyLoader ? (
                            <tr><td colSpan="2"><GearSpinner /></td></tr>
                        ) : filteredHistoryData.length === 0 ? (
                            <tr><td colSpan="2">No matching records found.</td></tr>
                        ) : filteredHistoryData.map((item, index) => (
                            <tr key={index}>
                                <td style={{ borderRight: "2px solid #fa4616" }}>
                                    <button className="btn-link-style-2" onClick={() => getPODetails(item.id)}>
                                        {item.order_number}
                                    </button>
                                </td>
                                <td>{item.order_date}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </React.Fragment>
        )
    }

    const renderCustomerInfo = () => {
        if (!poDetails?.order?.customer_name) return null;
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="table-responsive">
                        <table className="table table-bordered techtop-purchase-order-table text-center">
                            <thead>
                                <tr>
                                    <th>Sales Rep</th>
                                    <th>Payment Terms</th>
                                    <th>FOB Point</th>
                                    <th>Carrier</th>
                                    <th>Ship Service</th>
                                    <th>Date Scheduled</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{poDetails.order.rep}</td>
                                    <td>{poDetails.order.payment_terms}</td>
                                    <td>{poDetails.order.fob_point}</td>
                                    <td>{poDetails.order.carrier}</td>
                                    <td>{poDetails.order.ship_service}</td>
                                    <td>{poDetails.order.date_schedule}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    const renderSalesData = () => (
        <div className="row">
            <div className="col-md-12">
                <div className="table-responsive">
                    {isEdit ? (
                        <EditPurchaseOrderTable
                            salesData={formPayload.sales_data}
                            setFormData={setFormPayload}
                            products={products}
                            productMap={productMap}
                            multiplierMap={multiplierMap}
                            multiplierOptions={multiplierOptions}
                            isCompany={isCompany}
                            rowErrors={rowErrors}
                        />
                    ) : (
                        <table className="table table-bordered techtop-purchase-order-table2">
                            <thead>
                                <tr>
                                    <th className="text-center">Item #</th>
                                    <th className="text-center">Type</th>
                                    <th className="text-center" style={{ width: "20%" }}>Number</th>
                                    <th className="text-center">Description</th>
                                    <th className="text-center">List Price</th>
                                    <th className="text-center">Qty Ordered</th>
                                    <th className="text-center">Net Price</th>
                                    {!isCompany && <th className="text-center">Multiplier</th>}
                                    <th className="text-center">Total Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                {poDetails.items.map((item, index) => (
                                    <tr key={index}>
                                        <td className="text-center">{index + 1}</td>
                                        <td className="text-center">{item.item_type}</td>
                                        <td>{item.product_number}</td>
                                        <td>{item.description}</td>
                                        <td className="text-center">${item.unit_price}</td>
                                        <td className="text-center">{item.quantity}</td>
                                        <td className="text-center">
                                            ${formatUSD(
                                                parseNumber(item.net_price) > 0
                                                    ? parseNumber(item.net_price)
                                                    : parseNumber(item.unit_price) * parseNumber(item.multiplier || 1)
                                            )}
                                        </td>
                                        {!isCompany && <td className="text-center">{item.multiplier}</td>}
                                        <td className="text-center">${item.total_price}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
                <div className="table-responsive my-5 quote-history-div">
                    <table className="table table-bordered techtop-purchase-order-table2">
                        <tbody>
                            <tr>
                                <td rowSpan="3" style={{ width: "70%" }}>
                                    <strong>Notes:</strong>
                                    <div className="notes-text">{poDetails.order.notes}</div>
                                </td>
                                <td className="text-end"><strong>Subtotal:</strong></td>
                                <td className="text-end"><strong>${isEdit ? formatUSD(formPayload.sub_total) : poDetails.order.sub_total}</strong></td>
                            </tr>
                            <tr>
                                <td className="text-end"><strong>Sales Tax:</strong></td>
                                <td className="text-end"><strong>${isEdit ? formatUSD(formPayload.sales_tax) : poDetails.order.sales_tax}</strong></td>
                            </tr>
                            <tr>
                                <td className="text-end"><strong>Total:</strong></td>
                                <td className="text-end"><strong>${isEdit ? formatUSD(formPayload.total) : poDetails.order.total}</strong></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p>{isEdit ? estTime : poDetails.order.est_timestamp}</p>
            </div>
        </div>
    );

    const renderButtons = () => isEdit && (
        <div className="row">
            <div className="d-flex w-100 justify-content-evenly gap-4">
                <button type="button" className="submit-button w-50" onClick={handleUdpate}>Update</button>
                <button type="button" className="btn btn-secondary w-50" onClick={handleResetEdit}>Cancel</button>
            </div>
        </div>
    );

    const renderPODetails = () => {
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="section-div1">
                            <div className="row">
                                <div className="col-md-7">
                                    {poDetails.company_details?.company_logo ? (
                                        <img
                                            src={poDetails.company_details.company_logo}
                                            alt={poDetails.company_details?.company_name || ''}
                                            title="Click to view Company Profile"
                                        />
                                    ) : (
                                        <div
                                            className="company-initials-circle"
                                            title="Click to view Company Profile"
                                        >
                                            {poDetails.company_details?.company_initials || ''}
                                        </div>
                                    )}
                                    <h3>{poDetails.order.company_name}</h3>
                                    <p className="m-0 text-20">{[poDetails.company_details?.address, poDetails.company_details?.city, poDetails.company_details?.state_name, poDetails.company_details?.zip].filter(Boolean).join(', ')}</p>
                                </div>
                                <div className="col-md-5">
                                    <h3 className="text-center">PO</h3>
                                    <table className="table table-bordered quote-table text-center w-100">
                                        <thead><tr><th>PO Number #</th><th>Date</th></tr></thead>
                                        <tbody><tr><td>{poDetails.order.order_number}</td><td>{poDetails.order.order_date}</td></tr></tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row pt-3">
                    <div className="col-md-6">
                        <table className="table table-bordered w-100" style={{ tableLayout: 'fixed' }}>
                            <thead><tr><th>Bill To:</th></tr></thead>
                            <tbody><tr><td style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>{poDetails.order.billing_address}</td></tr></tbody>
                        </table>
                        {poDetails.order.customer_name && (
                            <table className="table table-bordered equal-table w-100" style={{ tableLayout: 'fixed' }}>
                                <tbody><tr><td style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>Customer: {poDetails.order.customer_name}</td></tr></tbody>
                            </table>
                        )}
                    </div>
                    <div className="col-md-6">
                        <table className="table table-bordered w-100" style={{ tableLayout: 'fixed' }}>
                            <thead><tr><th>Ship To: US</th></tr></thead>
                            <tbody><tr><td style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>{poDetails.order.shipping_address}</td></tr></tbody>
                        </table>
                    </div>
                </div>
                {renderCustomerInfo()}
                {renderSalesData()}
                {renderButtons()}
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <style>
                {`
                .history-toggle-btn {
                    position: absolute;
                    top: 150px;
                    left: ${showHistory ? 'calc(25% + 15px)' : '0px'};
                    transform: translateX(-50%);
                    z-index: 1050;
                    background: #fa4616;
                    color: white;
                    border: 1px solid #d33a12;
                    border-radius: 50%;
                    width: 30px;
                    height: 30px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
                }
                .history-toggle-btn:hover { background: #d33a12; scale: 1.1; }
                .sidebar-col { 
                    transition: all 0.3s ease; 
                    ${!showHistory ? 'width: 0; opacity: 0; padding: 0; margin: 0; overflow: hidden;' : 'width: 25%; flex: 0 0 25%; max-width: 25%;'}
                }
                .content-col { transition: all 0.3s ease; }
                @media (max-width: 767.98px) {
                    .history-toggle-btn { display: none !important; }
                    .sidebar-col {
                        width: 100% !important;
                        opacity: 1 !important;
                        margin-bottom: 10px !important;
                    }
                    .sidebar-col > div {
                        min-width: 0 !important;
                        padding: 0 !important;
                    }
                    .content-col {
                        width: 100% !important;
                        padding: 0 !important;
                    }
                }
                @media print { .history-toggle-btn { display: none !important; } }
                `}
            </style>
            <AlertMessage
                type={alert.type}
                message={alert.message}
                onClose={() => setAlert({ type: '', message: '' })}
            />

            <div className="container tab-pane active" id="po-history" style={{ position: 'relative' }}>
                <div className="row flex-nowrap g-0">
                    {isEdit && (
                        <button
                            className="history-toggle-btn"
                            onClick={() => setShowHistory(!showHistory)}
                            type="button"
                        >
                            {showHistory ? '❮' : '❯'}
                        </button>
                    )}

                    <div className="sidebar-col">
                        <div style={{ padding: '0 10px' }}>
                            <h5 className="text-center dark-color1">Previous PO</h5>
                            <div className="input-group mb-3">
                                <button className="btn btn-outline-secondary" type="button"><img src={searchIcon} alt="search" /></button>
                                <input type="text" className="form-control" placeholder="Search" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                            </div>
                            <div className="techtop-purchase-order-list-div">{renderHistoryTable()}</div>
                        </div>
                    </div>

                    {/* Middle Class Logic updated: col-md-12 when history hidden, col-md-7 when shown */}
                    <div className={`content-col print-area ${!showHistory ? 'col-md-12' : (isEdit || !detailLoader && !poDetails) ? 'col-md-9' : 'col-md-7'}`} id="printable" style={{ padding: '0 20px' }}>
                        {/* <AlertMessage
                            type={alert.type}
                            message={alert.message}
                            onClose={() => setAlert({ type: '', message: '' })}
                        /> */}
                        <Loader isLoading={detailLoader} message="Processing..." />
                        {!detailLoader && !poDetails && renderDefaultDetails()}
                        {!detailLoader && poDetails && renderPODetails()}
                    </div>

                    {/* Right column (Buttons) - logic remains. Note: col-md-12 will push this down in a normal row */}
                    {!detailLoader && poDetails && !isEdit && (
                        <div className="col-md-2 ps-3">
                            <ul className="net-pricing-report-list">
                                <li><button className="btn-link-style" onClick={handleEdit}><img src={editIcon} alt="Edit" /> Edit</button></li>
                                <li><button className="btn-link-style" onClick={handlePrint}><img src={printIcon} alt="Print" /> Print</button></li>
                                <li><button className="btn-link-style" onClick={handleShareClick}><img src={shareIcon} alt="Share" /> Share</button></li>
                                <li><button className="btn-link-style" onClick={exportPdf}><img src={pdfIcon} alt="PDF" /> Export PDF</button></li>
                                {/* <li><button className="btn-link-style" onClick={exportExcel}><img src={xlsIcon} alt="Excel" /> Export Excel</button></li> */}
                            </ul>
                        </div>
                    )}
                </div>

                <Loader isLoading={showLoader} message="Processing..." />
                <SharePurchaseOrderModal isShow={showShareModal} onClose={() => setShowShareModal(false)} onShare={handleShare} />
            </div>
        </React.Fragment>
    )
}

export default SavedPO;